import { render, staticRenderFns } from "./markList.vue?vue&type=template&id=6e94b15e&scoped=true&"
import script from "./markList.vue?vue&type=script&lang=js&"
export * from "./markList.vue?vue&type=script&lang=js&"
import style0 from "./markList.vue?vue&type=style&index=0&id=6e94b15e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e94b15e",
  null
  
)

export default component.exports